import classNames from 'classnames'

import styles from './apple.module.scss'
import type { BrandColor } from '@app-types/color'
import type { IconComponent } from '@components/icons/types'

/** Apple logo  */
export const Apple: IconComponent<Props> = ({
    width,
    height,
    color,
    className,
    ...restOfProps
}) => (
    <svg
        width={width}
        height={height}
        viewBox='0 0 16 19'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={classNames(className, styles[`fill-${color}`], styles.apple)}
        {...restOfProps}
    >
        <path d='M7.97 4.38C8.83 4.38 9.9 3.8 10.54 3.03C11.12 2.33 11.54 1.35 11.54 0.37C11.54 0.24 11.53 0.1 11.5 0C10.55 0.04 9.4 0.64 8.71 1.45C8.17 2.07 7.67 3.03 7.67 4.02C7.67 4.16 7.69 4.31 7.71 4.36C7.78 4.37 7.87 4.38 7.97 4.38ZM4.95 19C6.12 19 6.64 18.21 8.1 18.21C9.59 18.21 9.91 18.97 11.22 18.97C12.5 18.97 13.36 17.79 14.17 16.63C15.08 15.3 15.45 14 15.47 13.94C15.39 13.92 12.93 12.91 12.93 10.1C12.93 7.66 14.86 6.56 14.97 6.48C13.69 4.64 11.74 4.6 11.21 4.6C9.77 4.6 8.6 5.47 7.86 5.47C7.06 5.47 6.01 4.65 4.77 4.65C2.4 4.65 0 6.61 0 10.3C0 12.59 0.89 15.02 1.99 16.59C2.95 17.91 3.77 19 4.95 19Z' />
    </svg>
)

interface Props {
    /** Main color */
    color?: BrandColor
}
